/**
 * Accommodation Enquire Button → Pontoon #inquiry-dialog bridge
 *
 * The Pontoon plugin's handleEnquireButtonClick() only resolves .enquire-button
 * clicks via .closest(".ctas") or .closest(".cruise.-hero"). Our theme's
 * accommodation cards use .accoms__card, which the plugin can't find,
 * causing a console error and no dialog.
 *
 * This script intercepts .enquire-button clicks inside .accoms__card during
 * the capture phase (before the plugin's handler on document.body), populates
 * the Pontoon #inquiry-dialog hidden fields from the card's .dataset, and
 * opens the dialog directly.
 */

document.addEventListener(
  'click',
  function (e) {
    const btn = e.target.closest('.enquire-button');
    if (!btn) return;

    // Only intercept clicks from accommodation cards
    const card = btn.closest('.accoms__card');
    if (!card) return;

    const dataset = card.querySelector('.dataset');
    if (!dataset) return;

    const inquiryDialog = document.getElementById('inquiry-dialog');
    if (!inquiryDialog) return;

    // Stop the event from reaching Pontoon's handler on document.body
    e.stopPropagation();
    e.preventDefault();

    // Populate the dialog hidden fields from the card's dataset
    var fieldMap = {
      ref: 'selected-cruise',
      departureDate: 'selected-departureDate',
      returnDate: 'selected-returnDate',
      nights: 'selected-nights',
      ship: 'selected-ship',
      operator: 'selected-operator',
      region: 'selected-region',
      grade: 'selected-grade',
      price: 'selected-price',
    };

    Object.keys(fieldMap).forEach(function (dataName) {
      var input = dataset.querySelector('input[name="' + dataName + '"]');
      var dialogField = document.getElementById(fieldMap[dataName]);
      if (dialogField) {
        dialogField.value = input ? input.value : '';
      }
    });

    // Cabin name comes from the card's title (e.g. "Owner's Suite")
    var titleInput = dataset.querySelector('input[name="title"]');
    var cabinName = titleInput ? titleInput.value : '';
    document.getElementById('selected-cabinName').value = cabinName;

    // Cruise name: read from the hero block on the page
    // 1. Try hero H1 text
    var heroTitle = document.querySelector('.hero__title, .pontoon-cruise-hero--fullwidth__title, .pontoon-cruise-hero--compact__banner-title, .pontoon-cruise-hero--split__title');
    var cruiseName = heroTitle ? heroTitle.textContent.trim() : '';
    // 2. Fallback: hero dataset hidden input
    if (!cruiseName) {
      var heroDataset = document.querySelector('.cruise.-hero .dataset input[name="title"]');
      if (heroDataset) cruiseName = heroDataset.value;
    }
    document.getElementById('selected-cruiseName').value = cruiseName;

    // Open the Pontoon dialog
    inquiryDialog.showModal();
  },
  true // capture phase — fires before Pontoon's bubbling handler
);
